import React from 'react';
import {FaAngleLeft, FaAngleRight, FaHouse} from "react-icons/fa6";
import corporationSearchService from "../../../../../services/web/corporation-search-service.js";
import projectUtils from "../../../../../utils/project-utils.js";

const SelectedPassagesButtons = ({passages, passage, clickedResult, selectedIndex}) => {
    const handlePrevNextPassage = (dir, index, utcCaptureTime, id) => {
        const formData = new FormData();
        formData.append('date', utcCaptureTime);
        formData.append('lane_code', passages[index].lane.code);
        formData.append('proc_id', id);

        const response = dir === "prev" ? corporationSearchService.previous(formData) : corporationSearchService.next(formData)
        response.then(data => {

            clickedResult(selectedIndex, data.data.imageUrl, data.data)
        })
            .catch(error => {
                console.error(error);
                let message = 'Erro ao realizar pesquisa.';

                if (error.response.status !== 500) {
                    message = error.response.data.message;
                }

                projectUtils.swalErrorMessage('', message, 'Ok');
            })
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-2">
            <div>
                <button
                    className="w-full px-4 py-2 bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded text-gray-700 transition-colors flex justify-center items-center cursor-pointer"
                    onClick={() => handlePrevNextPassage("prev", selectedIndex, passage?.utcCaptureTime, passage?.id)}
                >
                    <FaAngleLeft/>
                </button>
            </div>
            <div>
                <button
                    className="w-full px-4 py-2 bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded text-gray-700 transition-colors flex justify-center items-center cursor-pointer"
                    onClick={() => clickedResult(selectedIndex, passages[selectedIndex].imageUrl, passages[selectedIndex])}
                >
                    <FaHouse/>
                </button>
            </div>
            <div>
                <button
                    className="w-full px-4 py-2 bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded text-gray-700 transition-colors flex justify-center items-center cursor-pointer"
                    onClick={() => handlePrevNextPassage("next", selectedIndex, passage?.utcCaptureTime, passage?.id)}
                >
                    <FaAngleRight/>
                </button>
            </div>
        </div>
    );
};

export default SelectedPassagesButtons;